import { getStoreState } from 'config/store'
import { getEmbed } from 'modules/embed/selectors'
import React, { useEffect, useState } from 'react'
import { setFontStyleSheet, setGlobalUserStyleSheet } from 'utils/styles'

import './style.css'

const ThemeStyleSheets = () => {
  const [hasLoadedFonts, setHasLoadedFonts] = useState(false)
  const embed = getEmbed(getStoreState())

  useEffect(() => {
    if (!hasLoadedFonts) {
      setFontStyleSheet(embed)
      setGlobalUserStyleSheet(embed)
      setHasLoadedFonts(true)
    }
  }, [embed, hasLoadedFonts])

  return (
    <div className="drift-widget-preload-fonts" aria-hidden="true">
      <span>A</span>
      <strong>B</strong>
    </div>
  )
}

export default ThemeStyleSheets
